import resourcesToBackend from "i18next-resources-to-backend";

// https://www.i18next.com/how-to/backend-fallback#you-can-also-lazy-load-the-in-memory-translations-i.e.-when-using-webpack
export const resource = resourcesToBackend(
  (lng: string, ns: string) => import(`~/lib/locale/locale-${lng}.json`)
);
